/*
 * Os modelos do editor (`canela-templates`, o TemplateResource do PHP) como
 * objetos simples, para o composer do fórum e para o painel do admin.
 *
 * O contrato dos campos é o de src/Templates/TemplateFields.php: o que está
 * entre `{{` e `}}` no texto é um campo, e `fields` descreve cada um (rótulo,
 * tipo, dica, opções, obrigatório). O texto final é o do modelo com cada
 * {{campo}} trocado pelo valor preenchido.
 */

export const TEMPLATES_TYPE = 'canela-templates';
export const FIELD_TYPES = ['text', 'textarea', 'select'];

/** Uma entrada do índice que o fórum recebe em toda página (`canelaTemplates`). */

/** O modelo inteiro, como vem da API. */

/** O mesmo padrão do PHP: até 60 caracteres, sem chaves nem quebra de linha. */
const placeholderPattern = () => /\{\{\s*([^{}\r\n]{1,60}?)\s*\}\}/gu;

/** As chaves dos campos, sem repetir, na ordem em que aparecem no texto. */
export function placeholders(body) {
  const pattern = placeholderPattern();
  const keys = [];
  let match;
  while ((match = pattern.exec(body)) !== null) {
    const key = match[1].trim();
    if (key && !keys.includes(key)) keys.push(key);
  }
  return keys;
}
export function defaultField(key) {
  return {
    key,
    label: key,
    type: 'text',
    placeholder: '',
    description: '',
    required: false,
    options: []
  };
}

/** Os campos do texto atual, mantendo a configuração dos que já existiam. */
export function syncFields(body, previous) {
  return placeholders(body).map(key => previous.find(field => field.key === key) ?? defaultField(key));
}

/** O texto final: cada {{campo}} trocado pelo valor (vazio quando não preenchido). */
export function render(body, values) {
  return body.replace(placeholderPattern(), (_match, key) => (values[key.trim()] ?? '').trim());
}

/** Os campos obrigatórios ainda em branco. */
export function missingRequired(fields, values) {
  return fields.filter(field => field.required && !(values[field.key] ?? '').trim());
}

/** Um campo como vem da API (o PHP já o normalizou; aqui só a forma). */
function fieldFrom(raw) {
  if (!raw || typeof raw !== 'object' || typeof raw.key !== 'string') return null;
  return {
    key: raw.key,
    label: typeof raw.label === 'string' && raw.label ? raw.label : raw.key,
    type: FIELD_TYPES.includes(raw.type) ? raw.type : 'text',
    placeholder: String(raw.placeholder ?? ''),
    description: String(raw.description ?? ''),
    required: !!raw.required,
    options: Array.isArray(raw.options) ? raw.options.map(String) : []
  };
}
export function templateFrom(resource) {
  const attrs = resource.attributes || {};
  const linkage = resource.relationships?.tags?.data;
  const fields = Array.isArray(attrs.fields) ? attrs.fields.map(fieldFrom).filter(Boolean) : [];
  return {
    id: Number(resource.id),
    name: String(attrs.name ?? ''),
    kind: attrs.kind === 'form' ? 'form' : 'text',
    required: !!attrs.required,
    tags: Array.isArray(linkage) ? linkage.map(item => Number(item.id)) : [],
    body: String(attrs.body ?? ''),
    fields,
    position: Number(attrs.position ?? 0) || 0
  };
}
export function templatesFrom(document) {
  const data = Array.isArray(document.data) ? document.data : [document.data];
  return data.map(templateFrom);
}
flarum.reg.add('ramon-canela', 'common/templates', { TEMPLATES_TYPE: TEMPLATES_TYPE,FIELD_TYPES: FIELD_TYPES,placeholders: placeholders,defaultField: defaultField,syncFields: syncFields,render: render,missingRequired: missingRequired,templateFrom: templateFrom,templatesFrom: templatesFrom, });